var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "资源选择",
        visible: _vm.centerDialogVisible,
        width: "35%",
        center: "",
        "append-to-body": "",
      },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "main" },
        _vm._l(_vm.dataArr, function (items, keys) {
          return _c(
            "div",
            { key: keys, staticClass: "mainLine" },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: keys },
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mainLineBox" },
                    _vm._l(items, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "mainLineBlock",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handlerSeeResClick(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.resourceName
                                  ? item.resourceName
                                  : item.resourceNameEn
                              ) +
                              "( "
                          ),
                          _vm._l(
                            item.orderListDetailResultList,
                            function (n, m) {
                              return _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(n.productName) +
                                    _vm._s(n.number + n.priceCompany)
                                ),
                                m !== item.orderListDetailResultList.length - 1
                                  ? _c("span", [_vm._v("、")])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _vm._v(") "),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
      _c("ResourceDetail", { ref: "resourceDetail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }